/**
 * Select dropdown widget.
 */

import type { FunctionComponent } from 'preact'

interface SelectOption {
  value: string
  label: string
}

interface SelectProps {
  value: string
  onChange: (value: string) => void
  options: SelectOption[]
  placeholder?: string
  disabled?: boolean
}

export const Select: FunctionComponent<SelectProps> = ({
  value,
  onChange,
  options,
  placeholder,
  disabled,
}) => {
  return (
    <select
      class="syv-input syv-select"
      value={value}
      disabled={disabled}
      onChange={(e) => onChange((e.target as HTMLSelectElement).value)}
    >
      {placeholder && (
        <option value="" disabled>
          {placeholder}
        </option>
      )}
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  )
}
